export const getResponsiveStyles = (theme, screenSize, isRTL) => {
  const { isMobile, isTablet, isLargeDesktop } = screenSize;

  const dark = theme === "dark";

  return {
    container: { marginTop: 0 },

    mainContent: {
      maxWidth: isLargeDesktop ? "1400px" : "1200px",
      margin: "0 auto",
      padding: isMobile ? "16px 0" : isTablet ? "24px 0" : "32px 0",
      position: "relative",
      zIndex: 1,
      marginTop: "-5%",
    },

    profileHeader: {
      background: dark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      padding: isMobile ? "16px" : isTablet ? "20px" : "24px",
      borderRadius: isMobile ? "12px" : "16px",
      transition: "all 0.3s ease",
      boxShadow: dark ? "0 8px 32px rgba(0,0,0,0.3)" : "0 8px 32px rgba(0,0,0,0.1)",
      WebkitBackdropFilter: dark ? "blur(25px) saturate(180%)" : "blur(10px)",
      border: dark ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
      cursor: "pointer",
      marginBottom: isMobile ? "16px" : isTablet ? "20px" : "24px",
    },

    profileHeaderContent: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "16px" : "32px",
      position: "relative",
      zIndex: 2,
      flexDirection: isMobile ? "column" : "row",
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    profileAvatarLarge: {
      width: isMobile ? "100px" : isTablet ? "120px" : "140px",
      height: isMobile ? "100px" : isTablet ? "120px" : "140px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #3b82f6, #0bb856ff)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontSize: isMobile ? "36px" : isTablet ? "42px" : "48px",
      fontWeight: "700",
      border: "4px solid rgba(255,255,255,0.2)",
      boxShadow: "0 10px 30px rgba(2,95,246,0.3)",
      position: "relative",
      flexShrink: 0,
    },

    avatarEditBtn: {
      position: "absolute",
      bottom: isMobile ? "4px" : "8px",
      [isRTL ? "left" : "right"]: isMobile ? "4px" : "8px",
      background: "rgba(255,255,255,0.9)",
      border: "none",
      borderRadius: "50%",
      width: isMobile ? "30px" : "36px",
      height: isMobile ? "30px" : "36px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#1e293b",
      transition: "all 0.3s ease",
    },

    profileInfo: { flex: 1, minWidth: 0 },

    profileName: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "24px" : isTablet ? "28px" : "32px",
      fontWeight: "700",
      margin: "0 0 8px 0",
      lineHeight: 1.2,
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    profileTitle: {
      color: "#2e7cba",
      fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
      fontWeight: "600",
      margin: "0 0 12px 0",
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    profileDepartment: {
      color: dark ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      fontSize: isMobile ? "14px" : "16px",
      margin: "0 0 20px 0",
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    contentGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "2fr 1fr",
      gap: isMobile ? "16px" : isTablet ? "20px" : "32px",
      alignItems: "start",
    },

    card: {
      background: dark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      WebkitBackdropFilter: dark ? "blur(25px) saturate(180%)" : "blur(10px)",
      border: dark ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
      borderRadius: isMobile ? "12px" : "20px",
      padding: isMobile ? "16px" : isTablet ? "20px" : "28px",
      boxShadow: dark ? "0 12px 40px rgba(0,0,0,0.15)" : "0 12px 40px rgba(0,0,0,0.08)",
      marginBottom: isMobile ? "16px" : "24px",
      transition: "all 0.3s ease",
      cursor: "pointer",
      direction: isRTL ? "rtl" : "ltr",
    },

    cardTitle: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
      fontWeight: "600",
      margin: "0 0 24px 0",
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "8px" : "12px",
    },

    infoGrid: { display: "grid", gap: isMobile ? "12px" : "16px" },

    infoItem: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "12px" : "16px",
      padding: isMobile ? "12px" : "16px",
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
      flexDirection: isMobile ? "column" : "row",
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    infoIcon: {
      width: isMobile ? "36px" : "44px",
      height: isMobile ? "36px" : "44px",
      background: "rgba(59,130,246,0.2)",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#60a5fa",
      flexShrink: 0,
    },

    infoContent: {
      flex: 1,
      minWidth: 0,
      textAlign: isMobile ? "center" : isRTL ? "right" : "left",
    },

    infoLabel: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: "13px",
      margin: "0 0 4px 0",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    infoValue: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: "15px",
      fontWeight: "500",
      margin: 0,
      wordWrap: "break-word",
    },

    skillsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(100px, 1fr))"
        : "repeat(auto-fit, minmax(120px, 1fr))",
      gap: "12px",
      marginTop: "16px",
    },

    skillTag: {
      background: "rgba(59,130,246,0.2)",
      color: "#60a5fa",
      padding: isMobile ? "6px 10px" : "8px 12px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "500",
      textAlign: "center",
      border: "1px solid rgba(59,130,246,0.3)",
    },

    statsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: isMobile ? "12px" : "20px",
      marginBottom: isMobile ? "16px" : "24px",
    },

    statCard: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: isMobile ? "12px" : "16px",
      padding: isMobile ? "16px" : "24px",
      textAlign: "center",
      transition: "all 0.3s ease",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
    },

    statIcon: { margin: "0 auto 12px", display: "block" },

    statValue: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "24px" : "28px",
      fontWeight: "700",
      margin: "8px 0 4px 0",
    },

    statLabel: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: "13px",
      margin: 0,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    progressBar: {
      background: dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
      borderRadius: "10px",
      height: isMobile ? "6px" : "8px",
      overflow: "hidden",
      marginTop: "8px",
    },

    progressFill: { height: "100%", borderRadius: "10px", transition: "width 0.6s ease" },

    achievementGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: isMobile ? "12px" : "16px",
      marginTop: "16px",
    },

    achievementCard: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      padding: isMobile ? "16px" : "20px",
      textAlign: "center",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
    },

    achievementIcon: { margin: "0 auto 12px", display: "block", color: "#fbbf24" },
    achievementTitle: { color: dark ? "white" : "#1a1a1a", fontSize: "14px", fontWeight: "600", margin: "0 0 4px 0" },
    achievementDate: { color: dark ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)", fontSize: "12px", margin: 0 },

    singleColumn: { gridColumn: "1 / -1" },

    twoColumn: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: isMobile ? "16px" : "24px",
    },

    threeColumn: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(auto-fit, minmax(250px, 1fr))",
      gap: isMobile ? "12px" : "20px",
    },

    projectItem: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      padding: isMobile ? "16px" : "20px",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
      marginBottom: "16px",
    },

    projectHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "8px" : "0",
    },

    projectName: { color: dark ? "white" : "#1a1a1a", fontSize: "16px", fontWeight: "600", margin: 0 },

    projectStatus: { padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "500" },

    projectTech: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: "14px",
      margin: 0,
      textAlign: isRTL ? "right" : "left",
    },

    activityItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: isMobile ? "12px" : "16px",
      padding: isMobile ? "12px" : "16px",
      background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
      borderRadius: "12px",
      marginBottom: "12px",
      border: dark ? "1px solid rgba(255,255,255,0.05)" : "1px solid rgba(0,0,0,0.03)",
    },

    activityIcon: {
      width: isMobile ? "32px" : "40px",
      height: isMobile ? "32px" : "40px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },

    activityContent: { flex: 1, minWidth: 0, textAlign: isRTL ? "right" : "left" },
    activityText: { color: dark ? "white" : "#1a1a1a", fontSize: isMobile ? "13px" : "14px", fontWeight: "500", margin: "0 0 4px 0" },
    activityTime: { color: dark ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)", fontSize: "12px", margin: 0 },
  };
};

export const getHoverStyles = (theme) => ({
  transform: "translateY(-5px)",
  boxShadow: theme === "dark" ? "0 12px 40px rgba(0,0,0,0.4)" : "0 12px 40px rgba(0,0,0,0.15)",
  background: theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.95)",
  border: theme === "dark" ? "1px solid rgba(255,255,255,0.2)" : "1px solid rgba(0,0,0,0.05)",
  WebkitBackdropFilter: theme === "dark" ? "blur(30px) saturate(200%)" : "blur(15px)",
});

export const getDefaultStyles = (theme) => ({
  transform: "translateY(0) scale(1)",
  boxShadow: theme === "dark" ? "0 8px 32px rgba(0,0,0,0.3)" : "0 8px 32px rgba(0,0,0,0.1)",
  background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
  border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
  WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
});